@if (this.address) {
  <div class="nps-address-field" [innerHTML]="'NPS.ADDRESS' | translate: { address: this.address }"></div>
}
